import { 
  HStack, 
  Link, 
  Menu, 
  MenuButton, 
  MenuList, 
  MenuItem, 
  Button,
  Box,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  VStack,
  IconButton,
  useBreakpointValue,
  Collapse,
  Text
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { ChevronDownIcon, HamburgerIcon } from '@chakra-ui/icons'
import { useState } from 'react'

const Navigation = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [openMenus, setOpenMenus] = useState({})
  
  const navItems = [
    { 
      label: 'Sites', 
      isMenu: true,
      menuItems: [
        { label: 'Sites Management', path: '/sites' },
        { label: 'Navigation Management', path: '/navigation' }
      ]
    },
    { 
      label: 'Content Types', 
      isMenu: true,
      menuItems: [
        { label: 'Content Models', path: '/content-models' },
        { label: 'Taxonomies', path: '/taxonomies' }
      ]
    },
    { label: 'Content', path: '/content' },
    { 
      label: 'Pages', 
      isMenu: true,
      menuItems: [
        { label: 'All Pages', path: '/pages' },
        { label: 'Component Library', path: '/component-library' },
        { label: 'Layout Library', path: '/layout-library' },
      ]
    },
    { 
      label: 'Testing', 
      isMenu: true,
      menuItems: [
        { label: 'A/B Tests', path: '/ab-testing' },
        { label: 'Create Test', path: '/ab-testing/create' }
      ]
    },
    { 
      label: 'Publishing', 
      isMenu: true,
      menuItems: [
        { label: 'Scheduled', path: '/scheduling' },
        { label: 'Schedule Content', path: '/scheduling/create' }
      ]
    },
    { label: 'Media', path: '/media' },
    { label: 'Settings', path: '/settings' },
  ]

  const toggleMobileMenu = (label) => {
    setOpenMenus(prev => ({
      ...prev,
      [label]: !prev[label]
    }))
  }

  return (
    <>
      {/* Desktop Navigation - Only shows on lg+ screens */}
      <HStack spacing={6} display={{ base: 'none', lg: 'flex' }}>
        {navItems.map((item) => (
          item.isMenu ? (
            <Menu key={item.label}>
              <MenuButton 
                as={Button} 
                rightIcon={<ChevronDownIcon />}
                variant="ghost"
                fontSize="sm"
                fontWeight="medium"
                color="gray.600"
                _hover={{ color: 'blue.500' }}
                size="sm"
              >
                {item.label}
              </MenuButton>
              <MenuList zIndex={1500}>
                {item.menuItems.map((menuItem) => (
                  <MenuItem 
                    key={menuItem.path} 
                    as={RouterLink} 
                    to={menuItem.path}
                    fontSize="sm"
                    _hover={{ bg: 'gray.50' }}
                  >
                    {menuItem.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          ) : (
            <Link
              key={item.path}
              as={RouterLink}
              to={item.path}
              fontSize="sm"
              fontWeight="medium"
              color="gray.600"
              _hover={{ color: 'blue.500' }}
            >
              {item.label}
            </Link>
          )
        ))}
      </HStack>

      {/* Mobile Navigation - Only shows on base to md screens */}
      <Box display={{ base: 'block', lg: 'none' }}>
        <IconButton
          icon={<HamburgerIcon />}
          variant="ghost"
          onClick={() => {
            console.log('Hamburger clicked!')
            onOpen()
          }}
          aria-label="Open navigation menu"
          size="md"
          color="gray.600"
          _hover={{ color: 'blue.500', bg: 'gray.100' }}
          border="1px solid"
          borderColor="gray.300"
          bg="white"
        />
        
        <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="xs">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader borderBottomWidth="1px">
              <Text fontSize="lg" fontWeight="bold">CMS Dashboard</Text>
            </DrawerHeader>

            <DrawerBody p={0}>
              <VStack spacing={0} align="stretch">
                {navItems.map((item) => (
                  <Box key={item.label}>
                    {item.isMenu ? (
                      <Box>
                        <Button
                          variant="ghost"
                          justifyContent="space-between"
                          rightIcon={<ChevronDownIcon 
                            transform={openMenus[item.label] ? 'rotate(180deg)' : 'rotate(0deg)'}
                            transition="transform 0.2s"
                          />}
                          onClick={() => toggleMobileMenu(item.label)}
                          w="full"
                          h="50px"
                          borderRadius="none"
                          fontSize="md"
                          fontWeight="medium"
                          color="gray.700"
                          _hover={{ bg: 'gray.50' }}
                        >
                          {item.label}
                        </Button>
                        
                        <Collapse in={openMenus[item.label]} animateOpacity>
                          <VStack spacing={0} align="stretch" bg="gray.50">
                            {item.menuItems.map((menuItem) => (
                              <Link
                                key={menuItem.path}
                                as={RouterLink}
                                to={menuItem.path}
                                onClick={onClose}
                                display="block"
                                px={6}
                                py={3}
                                fontSize="sm"
                                color="gray.600"
                                _hover={{ bg: 'gray.100', color: 'blue.500' }}
                                borderLeft="4px solid transparent"
                                _activeLink={{ 
                                  borderLeftColor: 'blue.500',
                                  color: 'blue.500',
                                  bg: 'blue.50'
                                }}
                              >
                                {menuItem.label}
                              </Link>
                            ))}
                          </VStack>
                        </Collapse>
                      </Box>
                    ) : (
                      <Link
                        as={RouterLink}
                        to={item.path}
                        onClick={onClose}
                        display="block"
                        px={4}
                        py={3}
                        fontSize="md"
                        fontWeight="medium"
                        color="gray.700"
                        _hover={{ bg: 'gray.50', color: 'blue.500' }}
                        borderLeft="4px solid transparent"
                        _activeLink={{ 
                          borderLeftColor: 'blue.500',
                          color: 'blue.500',
                          bg: 'blue.50'
                        }}
                      >
                        {item.label}
                      </Link>
                    )}
                  </Box>
                ))}
              </VStack>
            </DrawerBody>

            <DrawerFooter borderTopWidth="1px">
              <Text fontSize="xs" color="gray.500">
                CMS Dashboard v1.0
              </Text>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      </Box>
    </>
  )
}

export default Navigation